// src/components/ReportCategoryModal/ReportCategoryModal.js
import { useState } from "react";
import { CloseIcon } from "../../assets/icons/icons";
import ReportPillarScore from "./ReportPillarScore";
import ScatterPlot from "../Charts/ScatterPlot";
import BarChart from "../Charts/BarChart";
import { useConfig, ChartType } from "../../contexts/ConfigContext";
import { useStrategicSuggestions } from "../../contexts/StrategicSuggestionsContext";
import "./modal.css";
import LinksByAudience from "../LinksByAudience";

const ReportCategoryModal = ({
  isOpen, closeModal, category
}) => {
  const [openAttr, setOpenAttr] = useState(null);
  const [expandedAttr, setExpandedAttr] = useState(null);
  const { config } = useConfig();
  const { strategicSuggestions } = useStrategicSuggestions();
  const { byAttrId: suggestionByAttrId } = strategicSuggestions;

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-fullscreen" onClick={closeModal}>
      <div
        className="modal-content-fullscreen"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header-fullscreen">
          <h2>{category.category_name}</h2>
          <CloseIcon onClick={closeModal} className="cancel-icon" />
        </div>

        <h3>Wellness Pillars</h3>
        {category.pillars.map((pillar, index) => {
          return (
          <ReportPillarScore
            key={index}
            pillarData={pillar}
          />
        )})}

        <h3 style={{ marginTop: 20 }}>Attributes</h3>
        {category.pillars.map((pillar, index) => (
          <div key={pillar.pillar_id} className="attribute-score-container">
            <h3>{pillar.pillar_name}</h3>
            {pillar.attributes.map((attr) => {
              const scores = attr.grade_breakdown.reduce((acc, curr) => {
                acc[curr.grade] = curr.number_of_respondents;
                return acc;
              }, {});
              const attrSuggestion = suggestionByAttrId[attr.attribute_id];
              return (
                <div key={attr.attribute_id} className="attribute-block">
                  <h4>{attr.attribute_name}</h4>
                  { config.chartType === ChartType.SCATTER
                      ? <ScatterPlot attr={scores} /> // TODO Scatter plot needs a whole other set of data
                      : <BarChart scores={scores} rubrik={config.gradeScale}/>
                  }
                  <div style={{ marginBottom: "1.5em" }} />
                  { attrSuggestion && (
                    <div className="suggestion-highlight">
                      <h3>Strategic Suggestion: {attrSuggestion.title}</h3>
                      <div
                        className="suggestion-toggle-row"
                        onClick={() =>
                          setExpandedAttr(expandedAttr === attr.attribute_id ? null : attr.attribute_id)
                        }
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          userSelect: "none",
                          fontWeight: "bold",
                          margin: "0.5em 0"
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            transition: "transform 0.2s",
                            transform: expandedAttr === attr.attribute_id ? "rotate(90deg)" : "rotate(0deg)",
                            marginRight: "0.5em"
                          }}
                        >
                          ▶
                        </span>
                        Find Out More
                      </div>
                      {expandedAttr === attr.attribute_id && (
                        <div className="suggestion-content">
                          <div dangerouslySetInnerHTML={{ __html: attrSuggestion.description }} />
                          {attrSuggestion.links && attrSuggestion.links.length > 0 && (
                            <LinksByAudience linksMap={attrSuggestion.linksMap} />
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  <hr className="attr-divider" />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ReportCategoryModal;
